import * as z from "zod/v4";
import { createHyperLinkToolParamsSchema } from "./create-hyper-link";

/**
 * Confirmation data structure for the create-hyper-link tool as it bubbles up
 * through the multi-agent chain (settings → returns-chat-v2 → triage).
 *
 * Each level wraps the inner data with routing info (thread IDs) so the
 * confirm phase can find the child thread to propagate confirmation to.
 */

/** What the user responded with in the frontend */
export const hyperLinkUserResponseSchema = z.object({ navigated: z.boolean() });

/** Level 2: run-platform-agent wraps create-hyper-link data with settings thread ID */
export const runPlatformAgentConfirmationDataSchema = z.object({
  routing: z.object({ settingsThreadId: z.string() }),
  innerConfirmationData: createHyperLinkToolParamsSchema,
});

/** Level 1: query-returns wraps run-platform-agent data with returns thread ID */
export const queryReturnsConfirmationDataSchema = z.object({
  routing: z.object({ childThreadId: z.string() }),
  innerConfirmationData: runPlatformAgentConfirmationDataSchema,
  userResponse: hyperLinkUserResponseSchema.optional(),
});
